export default __webpack_public_path__ + "static/media/after@2x.cb696769.png";